import dig from 'object-dig';
import { List } from 'immutable';
import { User } from '../../stores/UserStore';
import JobSpec from '../../stores/specs/JobSpec';
import JobTaskSpec from '../../stores/specs/JobTaskSpec';

export const decompileConfigFromJob = (job) => {
  if (job) {
    if (job.jobType === 'giraffe') {
      return new List(job.config.map(task => (
        new JobTaskSpec({
          name: task.name,
          jobType: task.jobType,
          config: JSON.stringify(task.config, null, 4),
        })),
      ));
    }
  }
  return null;
};

export const refreshJobState = (props) => {
  const jobTasks = props.savedJob.config ?
    decompileConfigFromJob(props.savedJob.config) :
    new List([JobTaskSpec.stockTask()]);

  return new JobSpec({
    name: dig(props.savedJob, 'name') || 'My Job',
    jobTasks,
    scheduledUserOptions: props.scheduledUserOptions || new List(),
    scheduledUser: dig(props.savedJob, 'runAsUserEmail') || null,
    scheduleCron: dig(props.savedJob, 'scheduleCron') || '',
  });
};

export const withEmptyUserOption = options =>
  options.splice(0, 0, new User({ id: 0, email: '' }));

export const determineActiveTask = (activeTask, deletedTaskIndex) => {
  if (deletedTaskIndex === activeTask) {
    return null;
  } else if (deletedTaskIndex > activeTask) {
    return activeTask;
  }
  return activeTask - 1;
};

// Move to an API call when the Jobservice route is set up
export const jobTypes = [
 { jobType: 'codepuller' },
 { jobType: 'event_publisher' },
 { jobType: 'fetcher' },
 { jobType: 'file_cat' },
 { jobType: 'giraffe' },
 { jobType: 'google_sheets' },
 { jobType: 'infer_types' },
 { jobType: 'matching_runner' },
 { jobType: 'push-to-everything' },
 { jobType: 'rrunner' },
 { jobType: 's3-to-sftp-py' },
 { jobType: 'spark_infer_types' },
 { jobType: 'sql_runner' },
 { jobType: 'start_job' },
 { jobType: 'influencers_app' },
 { jobType: 'ohio_enight_reporting' },
 { jobType: 'push_to_google_sheets' },
 { jobType: 'google_trends_to_s3' },
];
